import {PositiveUnits} from '@mintdata/mint-kit/api/models/PositiveUnits';
import {IPropertyTypeConfig} from '@mintdata/mint-kit/api/properties/PropertyTypeConfig';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {
    PositiveUnitsConverter,
    PositiveUnitsStringConverter,
    SimplePositiveUnitsConverter
} from '@mintdata/mint-kit/impl/properties/converters/PositiveUnitsConverter';
import {PositiveUnitsEditor} from '@mintdata/mint-kit/impl/properties/editors/PositiveUnitsEditor';
import {PositiveUnitsStringEditor} from '@mintdata/mint-kit/impl/properties/editors/PositiveUnitsStringEditor';

export const SimplePositiveUnitsConfig:IPropertyTypeConfig<PositiveUnits> =
    {
        converter: SimplePositiveUnitsConverter,
        editor: PositiveUnitsStringEditor
    };

export const PositiveUnitsStringConfig:IPropertyTypeConfig<AString> =
    {
        converter: PositiveUnitsStringConverter,
        editor: PositiveUnitsStringEditor
    };

export const PositiveUnitsConfig:IPropertyTypeConfig<PositiveUnits> =
    {
        converter: PositiveUnitsConverter,
        editor: PositiveUnitsEditor
    };
